// extracted by mini-css-extract-plugin
module.exports = {"balance":"BalanceButton_balance__xHh8t","balanceHidden":"BalanceButton_balanceHidden__-7Sbm","infoImg":"BalanceButton_infoImg__3BAep"};